import React from 'react';

import Notification from '../Notification/Notification';

/**
 * Notification to the user to say that the treatment the would like is already in their basket.
 */
const AlreadyInBasketNotification = () => {
    // TODO: fix types
    // @ts-ignore
    const { setBasketIsOpen } = useBasketContext();

    const openBasket = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setBasketIsOpen((s: boolean) => !s);
    };

    return (
        <Notification>
            This item is already in your basket,{' '}
            <button type="button" onClick={openBasket} className="type-link">open basket</button>
        </Notification>
    );
};

export default AlreadyInBasketNotification;
